const TAB_ASSOCIATE = '1';
const TAB_ASSOCIATED = '2';

const DEFAULT_ACTIVE_TAB = TAB_ASSOCIATED;

export { TAB_ASSOCIATE, TAB_ASSOCIATED, DEFAULT_ACTIVE_TAB };
